import React from "react";
import michaelImg from "../assets/michael.png";
import kevinImg from "../assets/Kevin.png";
import joelImg from "../assets/joel.png";
import akeemImg from "../assets/akeem.png";
import kurnImg from "../assets/kurn.png";
import useReveal from "../hooks/useReveal";

const TEAM = [
  { name: "Michael Anton", position: "Managing Director", imgSrc: michaelImg },
  { name: "Kevin Wakefield", position: "Operations Director", imgSrc: kevinImg },
  { name: "Joel Noreiga", position: "HSE Coordinator", imgSrc: joelImg },
  { name: "Akeem Jones", position: "QA / QC Officer", imgSrc: akeemImg },
  { name: "Kurn Brewster", position: "Toolshop Manager", imgSrc: kurnImg },
];

function TeamMember({ member, index }) {
  const ref = useReveal();

  return (
    <figure
      ref={ref}
      style={{ "--reveal-delay": `${index * 90}ms` }}
      className="group reveal relative overflow-hidden border border-white/10 bg-ink-900"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={member.imgSrc}
          alt={member.name}
          loading="lazy"
          className="h-full w-full object-cover object-top grayscale transition-all duration-[900ms] ease-out group-hover:scale-105 group-hover:grayscale-0"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/25 to-transparent" />
        {/* Orange wash that fades in on hover */}
        <div className="absolute inset-0 bg-flame-600/0 transition-colors duration-500 group-hover:bg-flame-600/15" />
        <span className="absolute left-4 top-4 font-mono text-[10px] tracking-wide2 text-flame-500">
          0{index + 1}
        </span>
      </div>

      <figcaption className="relative p-5">
        <span className="absolute inset-x-0 top-0 h-[2px] origin-left scale-x-0 bg-flame-500 transition-transform duration-500 group-hover:scale-x-100" />
        <h3 className="h-display text-2xl leading-tight">{member.name}</h3>
        <p className="mt-1 font-mono text-[10px] uppercase tracking-wide2 text-flame-500">
          {member.position}
        </p>
      </figcaption>
    </figure>
  );
}

export default function Team() {
  const headRef = useReveal();

  return (
    <section
      id="team"
      className="relative overflow-hidden bg-ink-900 py-24 lg:py-32"
    >
      <div className="absolute inset-0 bg-grid bg-grid opacity-25" />

      <div className="relative mx-auto max-w-shell px-6 lg:px-10">
        <div
          ref={headRef}
          className="reveal mb-14 flex flex-col gap-6 lg:mb-20 lg:flex-row lg:items-end lg:justify-between"
        >
          <div>
            <p className="kicker mb-6 max-w-xs">04 — People</p>
            <h2 className="h-display text-5xl sm:text-6xl lg:text-7xl">
              Meet our
              <br />
              <span className="text-flame-500">team</span>
            </h2>
          </div>
          <p className="max-w-md text-steel-400">
            Supervision, quality, HSE and toolshop leadership — the people who
            plan the job before the tools ever go in the hole.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-5 md:grid-cols-3 lg:grid-cols-5">
          {TEAM.map((member, i) => (
            <TeamMember key={member.name} member={member} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
